<template lang="pug">
  .analise()
    app-modal-selecionar-tipo-processo(
      v-if="abrirModal"
      :tipos="tipos"
      :usuario="usuarioSelecionado"
      @closeModal="fecharModal"
    )
    el-card
      app-divider.margin-top(
        label="Gerenciamento de processos / usuários",
        :showBorder="false")
      app-search.extra-margin-top(
        @input="buscaSimples",
        v-model="search")
      app-divider.margin-top(label="Usuários")
      el-table.texto(
        :data='perfisUsuarios',
      )
        el-table-column(
          label='Nome'
          :formatter="formatNome"
        )
        el-table-column(
          label='Processos Vinculados'
          :formatter="formatProcessos"
        )
        el-table-column(
          label='Ações',
          width='120',
          align='center'
        )
          template(slot-scope='scope')
            el-dropdown(trigger="click")
              el-button(type='primary', size="small")
                | Ações
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot='dropdown')
                el-dropdown-item
                  .flex(@click="abreModal(scope.row)")
                    i.material-icons trending_up
                    | &nbsp Gerenciar Permissões
    div
      el-button.btn-voltar.margin-top(
        type="default",
        @click="voltar"
      )
        i.fa.fa-chevron-left
        b &nbsp Voltar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppSearch from '@/components/AppSearch'
import AppDivider from '@/components/AppDivider'
import AppModalSelecionarTipoProcesso from './components/modal/AppModalSelecionarTipoProcesso'
const { perfilSetor } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppSearch,
    AppDivider,
    AppModalSelecionarTipoProcesso
  },

  data () {
    return {
      usuarioSelecionado: null,
      usuarios: [],
      usuariosDefault: [],
      tipos: [],
      renderComponent: true,
      perfis: [],
      search: '',
      abrirModal: false
    }
  },

  async created () {
    this.tipos = await this.getTipoProcesso()
    this.usuarios = await this.getUsuarioPerfilTipo(this.usuario.perfilSelecionado.setor.codigo)
    this.perfis = await perfilSetor(this.getPerfilSetor, this.usuario.perfilSelecionado.setor.codigo)
    this.usuariosDefault = this.usuarios
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    perfisUsuarios () {
      return this.perfis.concat(this.usuarios)
    }
  },

  methods: {
    ...mapActions({
      getTipoProcesso: 'processo/getTipoProcesso',
      getUsuarioPerfilTipo: 'vinculoDistribuicaoProcesso/getUsuarioPerfilTipo',
      getPerfilSetor: 'vinculoDistribuicaoProcesso/getPerfilSetor'
    }),

    async buscaSimples (nome) {
      let nomeMin = nome.toLowerCase()
      this.usuarios = nome ? this.usuariosDefault.filter(user => user.pessoa.nomeRazaoSocial.toLowerCase().includes(nomeMin))
        : this.usuariosDefault
    },

    voltar () {
      this.$router.push({
        name: 'CAIXA_ENTRADA'
      })
    },

    formatNome (row) {
      if (row.pessoa) {
        let setorPerfil = ''
        switch (this.usuario.perfilSelecionado.setor.codigo) {
          case 'GCG':
          case 'CGIR':
            setorPerfil = 'GCG_CGIR'
            break
          case 'GRF':
          case 'CAF':
            setorPerfil = 'GRF_CAF'
            break
          default:
            setorPerfil = this.usuario.perfilSelecionado.setor.codigo
            break
        }
        return `${row.pessoa.nomeRazaoSocial} (${row.perfis.find(p => setorPerfil.includes(p?.setor?.codigo))?.nome})`
      }
      return row.nome
    },

    formatProcessos (row) {
      let vinculos = ''
      let aux = ''
      if (!row.pessoa) {
        let tipos = row.vinculos.map(v => v.tipoCadastro).map(t => t.nome)
        let tiposUnicos = [...new Set(tipos)]
        const tamanho = tiposUnicos.length - 1
        tiposUnicos.forEach((t, i) => {
          tamanho > i ? vinculos = aux.concat(vinculos, t, ' - ') : vinculos = aux.concat(vinculos, t)
        })
      } else {
        const tamanho = row.vinculos.length - 1
        row.vinculos.map((vinculo, i) => {
          tamanho > i ? vinculos = aux.concat(vinculos, vinculo.tipoCadastro.nome, ' - ') : vinculos = aux.concat(vinculos, vinculo.tipoCadastro.nome)
        })
      }
      return vinculos
    },

    abreModal (usuario) {
      try {
        const perfil = usuario.perfis.find(p => p.setor && (p.setor.codigo === 'DJ' || p.setor.codigo === 'GEO' || p.setor.codigo === 'CAF' || p.setor.codigo === 'GRF' || p.setor.codigo === 'GAC'))
        this.usuarioSelecionado = {id: usuario.id, nome: usuario.pessoa.nomeRazaoSocial, perfil: perfil, vinculos: usuario.vinculos, pessoa: usuario.pessoa}
      } catch (e) {
        this.usuarioSelecionado = usuario
      }
      this.abrirModal = true
    },

    async fecharModal () {
      this.abrirModal = false
      this.usuarios = await this.getUsuarioPerfilTipo(this.usuario.perfilSelecionado.setor.codigo)
      this.usuariosDefault = this.usuarios
      this.perfis = await this.getPerfilSetor(this.usuario.perfilSelecionado.setor.codigo)
    }
  }
}
</script>

<style>
.flex {
  display: flex;
  align-items: center;
  justify-content: left;
}

.btn-voltar {
  padding-left: 0px;
  border: none;
}

.btn-voltar:hover {
  background: none;
}

.texto {
  font-size: 17px;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/GestaoProcessoUsuario.vue